export default "__VITE_ASSET__BjP15q$y__"